import axios, {AxiosRequestConfig} from "axios";
import {auth} from "@/firebase";
import {SEE_ALL_HEADER, seeingAll, systemOfUrl} from "@/utils/seeAll";

const env = process.env.NODE_ENV

const prodURL = 'https://api.lunedi.org'
//const prodURL = 'https://d3o84oxhkibq8a.cloudfront.net' //AWS

const devURL = 'http://localhost:3000' //testar em ambiente local de dev
//const devURL = prodURL; //testar produção


const baseURL = env === 'development' ? devURL : prodURL;  //AWS
const http = axios.create({baseURL})

http.interceptors.request.use(
    async config => {
        // Se quem chamou já forneceu um token (ex.: o login, que tem o token do
        // signIn em mãos), respeita-o em vez de sobrescrever com o currentUser,
        // que pode estar defasado.
        if (config.headers?.Authorization) return config;

        const user = auth.currentUser;

        if (user) {
            const token = await user.getIdToken(); // 🔥 token sempre válido
            config.headers.Authorization = `Bearer ${token}`;
        }

        //A chave-mestra, quando ligada no ambiente desta requisição — ver o `seeAll`
        const system = systemOfUrl(config.url)
        if (system && seeingAll(system)) config.headers[SEE_ALL_HEADER] = '1';

        return config;
    },
    err => Promise.reject(err)
);

// Shared lock: ensures concurrent 401s trigger only a single token refresh
let refreshingToken: Promise<string> | null = null;

// Response interceptor: retry once on 401 by refreshing the Firebase token
http.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config as AxiosRequestConfig & { _retried?: boolean };

        // Only attempt retry for 401 responses that haven't already been retried
        if (error.response?.status === 401 && !originalRequest._retried) {
            originalRequest._retried = true;

            const user = auth.currentUser;
            if (!user) {
                // User is genuinely logged out — reject normally
                return Promise.reject(error);
            }

            try {
                // If no refresh is in progress, start one and store the promise
                if (!refreshingToken) {
                    refreshingToken = user.getIdToken(true).finally(() => {
                        refreshingToken = null;
                    });
                }

                // All concurrent 401s await the same refresh promise
                const newToken = await refreshingToken;

                // Update the Authorization header and resend the original request
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return http(originalRequest);
            } catch (_refreshError) {
                // Token refresh failed — session is truly invalid, reject normally
                return Promise.reject(error);
            }
        }

        return Promise.reject(error);
    }
);

export default http